import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss']
})

export class ErrorPageComponent {

constructor(private translate: TranslateService){
    if(localStorage.getItem('lang')==null){
        this.translate.setDefaultLang('en');
        this.translate.use('en');
      }else{
        this.translate.use(localStorage.getItem('lang'));
      }
}
}